import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import { Search } from '../../../../assets/images/index';

import { WrapperSearch, InputSearch, ButtonSearch } from './style';

const SearchComponent = ({ className, onClick, value, onChange, refs }) => (
  <div className={className}>
    <WrapperSearch>
      <InputSearch
        type="text"
        name="search"
        autoComplete="off"
        value={value}
        onChange={onChange}
        innerRef={r => refs.store('inputSearch', r)}
      />
      <ButtonSearch onClick={onClick}>
        <Icon svg={Search} size="m" color="light" hover />
      </ButtonSearch>
    </WrapperSearch>
  </div>
);

SearchComponent.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func
};

SearchComponent.defaultProps = {
  onClick: undefined
};

export default SearchComponent;
